import axiosApi, { setHeader } from "api/root.api";

export const refreshToken = async (body) => {
  const urlEnd = "/platform/account/v1/refreshToken";
  const response = await axiosApi.post(urlEnd, body);
  const result = response.data;
  return result;
};
